const lipFiller = {
  hero: {
    titlePrefix: "Premium",
    titleAccent: "Lippenunterspritzungen",
    description:
      "Unterstreichen Sie Ihre natürliche Schönheit mit unseren sicheren und effektiven Lippenvergrößerungsbehandlungen, die entwickelt wurden, um Ihnen die perfekten, vollen Lippen zu geben, die Sie sich immer gewünscht haben.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Ablauf erfahren",
    },
    imageAlt:
      "Frau mit vollen, natürlich aussehenden Lippen nach Filler-Behandlung",
    callout: {
      title: "Natürlich aussehende Ergebnisse",
      body:
        "Unsere Lippenfüller unterstreichen Ihre natürliche Schönheit, ohne übertrieben zu wirken.",
    },
  },
  benefits: {
    headingPrefix: "Vorteile von",
    headingAccent: "Lippenfüllern",
    intro:
      "Entdecken Sie, wie unsere Premium-Lippenfüller Ihre Gesichtsästhetik verbessern und Ihr Selbstvertrauen stärken können.",
    items: [
      {
        title: "Natürliche Verbesserung",
        description:
          "Unsere Füller verbessern Ihre natürliche Lippenform, anstatt einen offensichtlich künstlichen Look zu erzeugen.",
      },
      {
        title: "Sofortige Ergebnisse",
        description:
          "Sehen Sie sichtbare Verbesserungen direkt nach Ihrer Behandlung mit minimaler Ausfallzeit.",
      },
      {
        title: "Anpassbares Volumen",
        description:
          "Wir können so viel oder so wenig Volumen hinzufügen, wie Sie wünschen, um Ihren perfekten Look zu erreichen.",
      },
      {
        title: "Verbesserte Lippenform",
        description:
          "Korrigieren Sie Asymmetrien und definieren Sie die Ränder Ihrer Lippen für ein ausgewogeneres Erscheinungsbild.",
      },
      {
        title: "Reduzierte feine Linien",
        description:
          "Glätten Sie vertikale Lippenfältchen und Falten um den Mundbereich.",
      },
      {
        title: "Vorübergehende Ergebnisse",
        description:
          "Genießen Sie die Flexibilität einer nicht-permanenten Lösung, die typischerweise 6-12 Monate hält.",
      },
    ],
  },
  process: {
    headingPrefix: "Unser Prozess der",
    headingAccent: "Lippenunterspritzung",
    intro:
      "Unsere Premium-Lippenunterspritzungen folgen einem sorgfältigen Prozess, um Sicherheit, Komfort und schöne, natürlich aussehende Ergebnisse zu gewährleisten.",
    steps: [
      {
        title: "Beratung",
        description:
          "Treffen Sie sich mit unserem Spezialisten, um Ihre Ziele und Erwartungen für Ihre Lippenvergrößerung zu besprechen.",
      },
      {
        title: "Behandlungsplanung",
        description:
          "Wir erstellen einen persönlichen Behandlungsplan, der auf Ihre Gesichtszüge und das gewünschte Ergebnis zugeschnitten ist.",
      },
      {
        title: "Vorbereitung",
        description:
          "Eine betäubende Creme wird aufgetragen, um Ihren Komfort während des Eingriffs zu gewährleisten.",
      },
      {
        title: "Injektion",
        description:
          "Unser Spezialist injiziert den Dermal Filler sorgfältig, um ein natürlich aussehendes Volumen und Definition zu erreichen.",
      },
      {
        title: "Ergebnisse",
        description:
          "Genießen Sie sofortige Ergebnisse, die sich in den nächsten Tagen noch wunderbar setzen werden.",
      },
    ],
  },
  faq: {
    headingAccent: "Häufig gestellte Fragen",
    intro:
      "Erhalten Sie Antworten auf häufige Fragen zu unseren Lippenunterspritzungen.",
    items: [
      {
        question: "Wie lange halten Lippenfüller?",
        answer:
          "Lippenfüller halten typischerweise zwischen 6 und 12 Monaten, abhängig von der Art des verwendeten Füllers und Ihrem individuellen Stoffwechsel. Im Laufe der Zeit baut der Körper den Füller natürlich ab, was regelmäßige Auffrischungen erfordert, um Ihren gewünschten Look zu erhalten.",
      },
      {
        question: "Ist die Lippenunterspritzung schmerzhaft?",
        answer:
          "Wir tragen vor der Behandlung eine betäubende Creme auf, um Beschwerden zu minimieren. Die meisten Patienten berichten nur von leichtem Druck oder einem leichten Zwicken während der Injektionen. Viele Lippenfüller enthalten auch Lidocain, ein lokales Betäubungsmittel, um den Komfort während des Eingriffs weiter zu verbessern.",
      },
      {
        question: "Wie schnell sehe ich Ergebnisse nach der Lippenunterspritzung?",
        answer:
          "Sie werden sofort nach Ihrer Behandlung eine Volumenzunahme sehen, obwohl es anfangs zu Schwellungen kommen kann. Die endgültigen Ergebnisse werden sichtbar, sobald die Schwellung abklingt, typischerweise innerhalb von 1-2 Wochen nach dem Eingriff.",
      },
      {
        question: "Wie lange ist die Erholungszeit bei Lippenfüllern?",
        answer:
          "Die meisten Patienten können sofort nach der Behandlung zu ihren normalen Aktivitäten zurückkehren. Sie können für 2-3 Tage leichte Schwellungen, Blutergüsse oder Empfindlichkeit verspüren. Wir empfehlen, intensive körperliche Aktivitäten für 24-48 Stunden nach dem Eingriff zu vermeiden.",
      },
      {
        question: "Sind Lippenfüller reversibel, wenn mir das Ergebnis nicht gefällt?",
        answer:
          "Ja, Füller auf Hyaluronsäurebasis (die wir verwenden) können mit einem Enzym namens Hyaluronidase aufgelöst werden, wenn Sie mit den Ergebnissen unzufrieden sind. Dies ist einer der Gründe, warum diese Füller so beliebt sind – sie bieten die Flexibilität der Umkehrbarkeit.",
      },
      {
        question: "Wer ist kein guter Kandidat für Lippenfüller?",
        answer:
          "Personen, die schwanger sind, stillen, bestimmte Autoimmunerkrankungen haben, aktive Fieberbläschen haben oder allergisch auf Inhaltsstoffe der Füller reagieren, sollten Lippenvergrößerungen vermeiden. Während Ihrer Beratung überprüfen wir Ihre Krankengeschichte, um sicherzustellen, dass Lippenfüller für Sie sicher sind.",
      },
    ],
  },
};

export default lipFiller;

